import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFile = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 256 256",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 256,
			height: 256,
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 16
		}),
		/* @__PURE__ */ _jsx("polyline", {
			points: "152 32 152 88 208 88",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 16
		})
	]
});
export { SvgFile as ReactComponent };
